import React, { useState, useEffect } from "react";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import "./JumboPay.scss";

const LevelTable = () => {
  const { getTextByKey, getDirection, getHtmlByKey } = useContent();
  const [levelFee, setLevelFee] = useState([]);
  const levelNames = ["beginner", "apprentice", "expert", "master"];
  const numberLevels = {
    beginner: "one",
    apprentice: "two",
    expert: "three",
    master: "four",
  };
  const colorLevels = {
    beginner: "green",
    apprentice: "blue",
    expert: "purple",
    master: "yellow",
  };
  const svgLevels = {
    beginner: (
      <div className="level-name">
        <svg
          width="43"
          height="43"
          viewBox="0 0 48 43"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="21.5" cy="21.5" r="21.5" fill="#12DEA1"></circle>
          <path
            d="M9.1002 25.4057C10.2995 25.3613 12.4506 26.3058 13.4007 26.9559C12.6506 27.856 10.3503 29.1061 9.1002 29.1061C7.85005 29.1061 6.99995 28.256 6.99995 27.3059C6.99995 26.3558 7.75004 25.4557 9.1002 25.4057Z"
            fill="#fff"
          ></path>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.4007 21.9053L8.65014 24.2556C8.58347 24.2556 8.45012 24.2956 8.45012 24.4556C8.45012 24.6156 8.58347 24.6556 8.65014 24.6556C8.65014 24.6556 10.2003 24.3556 12.2506 25.4057C13.1173 25.9224 15.0909 27.1159 16.051 27.756C16.1919 27.8499 16.3755 27.992 16.5981 28.1644C18.2718 29.4603 22.1504 32.4633 26.6523 29.5062C27.5857 28.8394 29.6226 27.2459 30.3027 26.2058H33.053C33.203 26.2391 33.5231 26.1858 33.6031 25.7057C33.61 25.6645 33.6315 25.5835 33.6624 25.4674C34.0805 23.895 36.2125 15.8777 26.8523 12.8042C26.6023 12.4542 25.8222 11.8441 24.7021 12.2041C22.7685 11.8541 18.3713 11.7041 16.2511 13.9043C16.0677 14.071 15.681 14.5144 15.601 14.9545C15.521 15.3945 14.1008 19.7717 13.4007 21.9053ZM14.6009 20.8551L16.4011 15.1045C16.5511 14.4544 17.8012 13.5766 19.5014 13.0542C22.2618 12.2062 26.0189 13.2676 27.5524 13.9043C29.0526 14.6544 29.8527 15.4045 29.8527 17.6548C30.0927 20.2951 29.3859 23.5221 29.0026 24.8056L24.7021 23.4555C20.3515 21.5052 15.3009 21.4052 14.7509 21.4052C14.3108 21.4052 14.4675 21.0385 14.6009 20.8551Z"
            fill="#fff"
          ></path>
        </svg>
        {getTextByKey("aboutjumbopay-level-beginner")}
      </div>
    ),
    apprentice: (
      <div className="level-name">
        <svg
          width="43"
          height="43"
          viewBox="0 0 43 43"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="21.5" cy="21.5" r="21.5" fill="#0CC4E9"></circle>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M32.9998 20.3092V19.7809L20.9946 14L9 19.7758V20.3142L20.9946 26.0901L32.9998 20.3092ZM13.1503 23.6541V27.1141L20.3914 30.6014H21.6082L28.8294 27.1237C28.8364 27.1085 28.8429 27.0933 28.8494 27.0779V23.6541L20.9998 27.4343L13.1503 23.6541ZM31.7557 21.9399V28.7077L32.3683 30.6047L31.4423 31.8646H31.1289L30.2029 30.6047L30.8155 28.7077V22.4218L31.7557 21.9399Z"
            fill="white"
          ></path>
        </svg>
        {getTextByKey("aboutjumbopay-level-apprentice")}
      </div>
    ),
    expert: (
      <div className="level-name">
        <svg
          width="43"
          height="43"
          viewBox="0 0 43 43"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="21.5" cy="21.5" r="21.5" fill="#CF70FB"></circle>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7309 12.3594L26.5906 12.3594C26.9825 12.3594 27.2946 12.6866 27.2767 13.0799L26.6896 25.558C23.3827 26.2799 18.9374 26.2799 15.6332 25.558L15.0447 13.0799C15.0255 12.6866 15.339 12.3594 15.7309 12.3594ZM27.8736 27.701L27.9864 25.5615C29.6818 25.6124 32 25.8736 32 27.6653C32 30.374 26.467 31.7903 21 31.7903C15.533 31.7903 10 30.374 10 27.6653C10 25.875 12.3182 25.6124 14.0136 25.5615L14.125 27.701C14.1415 28.0035 14.3533 28.2606 14.6475 28.3321C16.5161 28.7955 18.7134 29.0403 21 29.0403C23.2866 29.0403 25.4839 28.7955 27.3525 28.3321C27.6467 28.2593 27.8571 28.0035 27.8736 27.701Z"
            fill="white"
          ></path>
        </svg>
        {getTextByKey("aboutjumbopay-level-expert")}
      </div>
    ),
    master: (
      <div className="level-name">
        <svg
          width="43"
          height="43"
          viewBox="0 0 43 43"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="21.5" cy="21.5" r="21.5" fill="#FEB82F"></circle>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.8077 17.8301C23.5099 17.5195 24 16.8169 24 16C24 14.8955 23.1046 14 22 14C20.8954 14 20 14.8955 20 16C20 16.7622 20.4262 17.4248 21.0532 17.7622L18.7794 20.7939C17.7001 22.2334 15.6057 22.4053 14.3058 21.1621L12.4453 19.3823C12.7889 19.0229 13 18.5361 13 18C13 16.8955 12.1046 16 11 16C9.89542 16 9 16.8955 9 18C9 19.1045 9.89542 20 11 20C11.0746 20 11.1483 19.9956 11.2209 19.9878L11.9506 26.5552C11.9787 26.8086 12.1927 27 12.4475 27H30.5525C30.8073 27 31.0213 26.8086 31.0494 26.5552L31.7791 19.9878C31.8517 19.9956 31.9254 20 32 20C33.1046 20 34 19.1045 34 18C34 16.8955 33.1046 16 32 16C30.8954 16 30 16.8955 30 18C30 18.5361 30.2111 19.0229 30.5547 19.3823L28.9494 20.918C27.5635 22.2437 25.3067 21.9463 24.3114 20.3071L22.8077 17.8301ZM12 28.5C12 28.2236 12.2238 28 12.5 28H30.5C30.7762 28 31 28.2236 31 28.5V30.5C31 30.7764 30.7762 31 30.5 31H12.5C12.2238 31 12 30.7764 12 30.5V28.5Z"
            fill="white"
          ></path>
        </svg>
        {getTextByKey("aboutjumbopay-level-master")}
      </div>
    ),
  };

  const getAllFeeLevels = async (id) => {
    const response = await apiRequest("JumboFee", "GetAllJMFeeLevels");
    if (response.status === "success") {
      setLevelFee(response.data);
    }
  };
  const getFeeLevelDetails = (name) => {
    if (!levelFee) return;
    if (levelFee.length === 0) {
      return;
    }
    const found = levelFee.find(
      (element) => element.Name.toLowerCase() === name
    );
    return found.FeeAmount;
  };

  useEffect(() => {
    getAllFeeLevels();
  }, []);
  return (
    <div className="level-table">
      <p className="table-explenation">
        {getTextByKey("aboutjumbopay-transaction-fee")}
      </p>
      <div className="levels">
        <div className="level table-head">
          <div
            className={`level-name ${
              getDirection() === "rtl" ? "" : "level-name-ltr"
            }`}
          >
            {getTextByKey("aboutjumbopay-tablehead-level")}
          </div>
          <div className="level-explenation">
            {getTextByKey("aboutjumbopay-tablehead-total")}
          </div>
          <div
            className={`level-percentage ${
              getDirection() === "rtl" ? "" : "level-percentage-ltr"
            }`}
          >
            {getTextByKey("aboutjumbopay-tablehead-fee")}
          </div>
        </div>

        {levelNames.map((ind) => {
          return (
            <div className={`level ${colorLevels[ind]}`}>
              {svgLevels[ind]}
              <div className="level-explenation">
                {getTextByKey(
                  `aboutjumbopay-tablebody-level-${numberLevels[ind]}`
                )}
              </div>
              <div
                className={`level-percentage ${
                  getDirection() === "rtl" ? "" : "level-percentage-ltr"
                }`}
              >
                {getFeeLevelDetails(ind) + "%"}
              </div>
            </div>
          );
        })}
      </div>
      <p className="comments">
        <small>{getHtmlByKey("aboutjumbopay-five-section-text-comment")}</small>
      </p>
    </div>
  );
};

export default LevelTable;
